import Store from 'd2-flux/store/Store';

export default Store.create();



/** WEBPACK FOOTER **
 ** ./app/docs-app/appState.store.js
 **/